import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import validator from 'validator';
import moment from 'moment';
import axios from 'axios';
import Toggle from 'react-toggle';
import DatePicker from 'react-datepicker';

import Layout from '../components/layout';
import Seo from '../components/seo';
import Autocomplete from '../components/mapbox-autocomplete/autocomplete';
import MultiSelect from '../components/visns-multi-select';

import 'react-toggle/style.css';
import 'react-datepicker/dist/react-datepicker.css';

const IndexPage = () => {
    const apiBaseUrl = process.env.GATSBY_API_URL;
    const apiToken = process.env.GATSBY_API_TOKEN;
    const logoUrl = process.env.GATSBY_LOGO;
    const [clinics, setClinics] = useState([]);
    const [data, setData] = useState({
        firstname: '',
        surname: '',
        mobile: '',
        email: '',
        dob: '',
        address: '',
        address1: '',
        suburb: '',
        postcode: '',
        state: '',
        country: '',
        site_id: '',
        clinic: '',
        practitioner_id: '',
        practitioner: '',
        treatment_id: '',
        treatment: '',
        bodyLocations: [],
        date: '',
        time: '',
        start: '',
        consent: false,
        status_id: 1,
        event_type_id: 1,
        source: 'external',
    });
    const [dataClass, setDataClass] = useState({
        firstname: '',
        surname: '',
        mobile: '',
        email: '',
        dob: '',
        address: '',
        address1: '',
        suburb: '',
        postcode: '',
        state: '',
        country: '',
        site_id: '',
        practitioner_id: '',
        treatment_id: '',
        bodyLocations: 'togglebox',
        date: '',
        time: '',
        consent: '',
    });
    const [datePlaceholder, setDatePlaceholder] = useState(
        'Please select a clinic.'
    );
    const [days, setDays] = useState({
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
    });
    const [errorVisible, setErrorVisible] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [includeDates, setIncludeDates] = useState([]);
    const [practitioners, setPractitioners] = useState([]);
    const [sending, setSending] = useState(false);
    const [treatment, setTreatment] = useState([]);
    const [treatments, setTreatments] = useState([]);
    const [times, setTimes] = useState([]);
    const [visible, setVisible] = useState('information');

    const handleDownload = (url) => {
        if (url && url !== '') {
            window.open(url);
        }
    };

    const handleChangeMs = (inputValue, action, id) => {
        setData((prevState) => ({
            ...prevState,
            [id]: inputValue,
        }));

        switch (id) {
            case 'treatment_id':
                getTreatment(inputValue);
                fetchLocations(inputValue);
                break;
            default:
                break;
        }
    };

    const handleChange = (e) => {
        if (e) {
            setData((prevState) => ({
                ...prevState,
                [e.target.name]:
                    e.target.type === 'checkbox'
                        ? e.target.checked
                        : e.target.value,
            }));

            switch (e.target.name) {
                case 'site_id':
                    setData((prevState) => ({
                        ...prevState,
                        practitioner_id: '',
                    }));

                    setData((prevState) => ({
                        ...prevState,
                        clinic: e.target.options[e.target.selectedIndex].text,
                    }));

                    clinics.forEach((a) => {
                        if (parseInt(a.id) === parseInt(e.target.value)) {
                            setDays((items) => ({
                                ...items,
                                ...a.days,
                            }));
                        }
                    });

                    setDatePlaceholder('Please select a Treating Clinician.');

                    axios
                        .post(
                            apiBaseUrl + 'contacts/dropdown',
                            {
                                where: [
                                    // {
                                    //     id: 'contact_type_id',
                                    //     value: 2,
                                    // },
                                    {
                                        id: 'active_site_id',
                                        value: e.target.value,
                                    },
                                ],
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${apiToken}`,
                                },
                            }
                        )
                        .then((res) => {
                            setPractitioners(res.data.data);
                        });

                    axios
                        .post(
                            apiBaseUrl + 'sitesAvailability/list',
                            {
                                site_id: e.target.value,
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${apiToken}`,
                                },
                            }
                        )
                        .then((res) => {
                            let dates = [];

                            res.data.forEach((a) => {
                                dates.push(new Date(a));
                            });

                            setIncludeDates(dates);
                        });
                    break;
                case 'practitioner_id':
                    axios
                        .post(
                            apiBaseUrl + 'treatments/dropdown',
                            {
                                where: [
                                    {
                                        id: 'assigned',
                                        value: e.target.value,
                                    },
                                ],
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${apiToken}`,
                                },
                            }
                        )
                        .then((res) => {
                            setTreatments(res.data.data);
                        });

                    setDatePlaceholder('Please select a date.');

                    setData((prevState) => ({
                        ...prevState,
                        practitioner:
                            e.target.options[e.target.selectedIndex].text,
                    }));
                    break;
                default:
                    break;
            }
        }
    };

    const handleAutocomplete = (place) => {
        let _address1 = place.address
            ? place.address + ' ' + place.text
            : place.text;
        let _suburb = place.context[1].text;
        let _postcode = place.context[0].text;
        let _state = place.context[2].text;
        let _country = place.context[3].text;

        setData((prevState) => ({
            ...prevState,
            address: place.place_name,
            address1: _address1,
            suburb: _suburb,
            postcode: _postcode,
            state: _state,
            country: _country,
        }));
    };

    const handleFilterDate = (date) => {
        const day = date.getDay(date);

        switch (day) {
            case 0 /** Sunday */:
                if (days.sunday === true) {
                    return day;
                }
                break;
            case 1:
                if (days.monday === true) {
                    return day;
                }
                break;
            case 2:
                if (days.tuesday === true) {
                    return day;
                }
                break;
            case 3:
                if (days.wednesday === true) {
                    return day;
                }
                break;
            case 4:
                if (days.thursday === true) {
                    return day;
                }
                break;
            case 5:
                if (days.friday === true) {
                    return day;
                }
                break;
            case 6:
                if (days.saturday === true) {
                    return day;
                }
                break;
            default:
                break;
        }
    };

    const handleNext = (id) => {
        let _error = '';

        switch (id) {
            case 'appointment':
                if (data.firstname === '') {
                    _error += 'Please enter your first name.<br />';

                    setDataClass((prevState) => ({
                        ...prevState,
                        firstname: 'inputerror',
                    }));
                }

                if (data.surname === '') {
                    _error += 'Please enter your last name.<br />';

                    setDataClass((prevState) => ({
                        ...prevState,
                        surname: 'inputerror',
                    }));
                }

                if (data.mobile === '') {
                    _error += 'Please enter your contact no.<br />';

                    setDataClass((prevState) => ({
                        ...prevState,
                        mobile: 'inputerror',
                    }));
                }

                if (data.email === '') {
                    _error += 'Please enter your email address.<br />';

                    setDataClass((prevState) => ({
                        ...prevState,
                        email: 'inputerror',
                    }));
                } else {
                    if (validator.isEmail(data.email) === false) {
                        _error += 'Please enter a valid email address.<br />';

                        setDataClass((prevState) => ({
                            ...prevState,
                            email: 'inputerror',
                        }));
                    }
                }

                // if (data.address === '') {
                //     _error += 'Please enter your address.<br />';

                //     setDataClass((prevState) => ({
                //         ...prevState,
                //         address: 'inputerror',
                //     }));
                // }
                break;
            case 'confirmation':
                if (data.site_id === '') {
                    _error += 'Please select a clinic.<br />';

                    setDataClass((prevState) => ({
                        ...prevState,
                        site_id: 'inputerror',
                    }));
                }

                if (data.practitioner_id === '') {
                    _error += 'Please select a practitioner.<br />';

                    setDataClass((prevState) => ({
                        ...prevState,
                        practitioner_id: 'inputerror',
                    }));
                }

                if (data.treatment_id === '') {
                    _error += 'Please select a treatment.<br />';

                    setDataClass((prevState) => ({
                        ...prevState,
                        treatment_id: 'inputerror',
                    }));
                }

                let _error_location =
                    'Please select a treatment location.<br />';

                data.bodyLocations.forEach((a) => {
                    a.locations.forEach((b) => {
                        if (b.value === true) {
                            _error_location = '';
                        }
                    });
                });

                if (_error_location !== '') {
                    _error += _error_location;

                    setDataClass((prevState) => ({
                        ...prevState,
                        bodyLocations: 'togglebox inputerror',
                    }));
                }

                if (data.time === '') {
                    _error += 'Please select a treatment time.<br />';

                    setDataClass((prevState) => ({
                        ...prevState,
                        time: 'inputerror',
                    }));
                }

                if (_error === '') {
                    setData((prevState) => ({
                        ...prevState,
                        start: moment(
                            moment(data.date).format('YYYY-MM-DD') +
                                ' ' +
                                data.time,
                            'YYYY-MM-DD hh:mma'
                        ),
                    }));
                }
                break;
            case 'success':
                setSending(true);

                axios
                    .post(apiBaseUrl + 'events', data, {
                        headers: {
                            Authorization: `Bearer ${apiToken}`,
                        },
                    })
                    .then((res) => {
                        if (res.data.error === '') {
                            setErrorVisible(false);
                            setErrorMsg('');

                            setVisible(id);

                            setDataClass({
                                firstname: '',
                                surname: '',
                                mobile: '',
                                email: '',
                                dob: '',
                                address: '',
                                address1: '',
                                suburb: '',
                                postcode: '',
                                state: '',
                                country: '',
                                site_id: '',
                                practitioner_id: '',
                                treatment_id: '',
                                bodyLocations: 'togglebox',
                                date: '',
                                time: '',
                                consent: '',
                            });
                        } else {
                            _error = res.data.error;
                        }
                    });
                break;
            default:
                break;
        }

        if (_error === '') {
            setSending(false);
            setErrorVisible(false);
            setErrorMsg('');

            setVisible(id);

            setDataClass({
                firstname: '',
                surname: '',
                mobile: '',
                email: '',
                dob: '',
                address: '',
                address1: '',
                suburb: '',
                postcode: '',
                state: '',
                country: '',
                site_id: '',
                practitioner_id: '',
                treatment_id: '',
                bodyLocations: 'togglebox',
                date: '',
                time: '',
                consent: '',
            });
        } else {
            setErrorVisible(true);
            setErrorMsg(_error);
        }
    };

    const handleToggleLocation = (e) => {
        if (e) {
            let _error = '';

            if (data.site_id === '') {
                if (data.site_id === '') {
                    _error += 'Please select a clinic.<br />';
                }
            }

            if (_error === '') {
                setErrorVisible(false);
                setErrorMsg('');

                let _locations = data.bodyLocations;
                _locations[e.target.dataset.parentcounter].locations[
                    e.target.dataset.counter
                ].value = e.target.checked;
                _locations[e.target.dataset.parentcounter].locations[
                    e.target.dataset.counter
                ].selected = e.target.checked === true ? 1 : 0;

                if (e.target)
                    setData((prevState) => ({
                        ...prevState,
                        bodyLocations: _locations,
                    }));
            } else {
                setErrorVisible(true);
                setErrorMsg(_error);
            }
        }
    };

    const getTreatment = (treatments) => {
        if (treatments.length > 0) {
            setTreatment([]);
            treatments.forEach((a) => {
                axios
                    .post(
                        `${apiBaseUrl}treatments/get/${a.value}`,
                        {},
                        {
                            headers: {
                                Authorization: `Bearer ${apiToken}`,
                            },
                        }
                    )
                    .then((res) => {
                        setTreatment((prevState) => [...prevState, res.data]);
                    });
            });
        }
    };

    const fetchLocations = (treatments) => {
        if (treatments.length > 0) {
            let _bodyLocations = data.bodyLocations;

            setData((prevState) => ({
                ...prevState,
                bodyLocations: [],
            }));

            treatments.forEach((a) => {
                axios
                    .post(
                        apiBaseUrl + 'treatmentDetails/dropdown',
                        {
                            where: [
                                {
                                    id: 'type',
                                    value: 'bodyLocation',
                                },
                                {
                                    id: 'treatment_id',
                                    value: a.value,
                                },
                            ],
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${apiToken}`,
                            },
                        }
                    )
                    .then((res) => {
                        let _locations = [];

                        res.data.data.forEach((b) => {
                            let _selected = 0;
                            let _value = false;

                            _bodyLocations.forEach((x) => {
                                x.locations.forEach((y) => {
                                    if (y.id === b.id) {
                                        if (y.value === true) {
                                            _selected = 1;
                                            _value = true;
                                        }
                                    }
                                });
                            });

                            _locations.push({
                                id: b.id,
                                label: b.label,
                                selected: _selected,
                                value: _value,
                            });
                        });

                        setData((prevState) => ({
                            ...prevState,
                            bodyLocations: [
                                ...prevState.bodyLocations,
                                {
                                    treatment_id: a.value,
                                    treatment: a.label,
                                    locations: _locations,
                                },
                            ],
                        }));
                    });
            });
        }
    };

    useEffect(() => {
        axios
            .post(
                apiBaseUrl + 'sites/dropdown',
                {
                    api: true,
                },
                {
                    headers: {
                        Authorization: `Bearer ${apiToken}`,
                    },
                }
            )
            .then((res) => {
                if (res.data.data.length > 0) {
                    setClinics(res.data.data);
                } else {
                    setErrorVisible(true);
                    setErrorMsg(
                        'No clinics are currently available, please contact the clinic to enquire.'
                    );
                }
            });
    }, [apiBaseUrl, apiToken]);

    useEffect(() => {
        if (
            data.site_id > 0 &&
            data.treatment_id.length > 0 &&
            data.bodyLocations.length > 0 &&
            data.practitioner_id > 0 &&
            data.date !== ''
        ) {
            axios
                .post(
                    apiBaseUrl + 'events/listAvailable',
                    {
                        site_id: data.site_id,
                        treatment_id: data.treatment_id,
                        bodyLocations: data.bodyLocations,
                        date: moment(data.date).format('YYYY-MM-DD'),
                        practitioner_id: data.practitioner_id,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${apiToken}`,
                        },
                    }
                )
                .then((res) => {
                    if (res.data.error === '') {
                        setTimes(res.data.data);
                    } else {
                        setErrorVisible(true);
                        setErrorMsg(res.data.error);
                    }
                });
        }
    }, [data, apiBaseUrl, apiToken]);

    return (
        <Layout>
            <Seo title="Book an Appointment" description="Digiclinic Booking" />
            <div className="app-content">
                <div className="bookings">
                    <img src={logoUrl} alt="Digiclinic" />
                    <h1>Request an Appointment</h1>
                    <div className="bookingsteps">
                        <div className="bookingsteps__item">
                            <div className="bookingsteps__item--label">
                                <span
                                    className={
                                        visible === 'information'
                                            ? 'stepno stepno--active'
                                            : 'stepno'
                                    }
                                >
                                    1
                                </span>
                                <span className="steptitle">Information</span>
                            </div>
                        </div>
                        <div className="bookingsteps__item">
                            <div className="bookingsteps__item--label">
                                <span
                                    className={
                                        visible === 'appointment'
                                            ? 'stepno stepno--active'
                                            : 'stepno'
                                    }
                                >
                                    2
                                </span>
                                <span className="steptitle">Appointment</span>
                            </div>
                        </div>
                        <div className="bookingsteps__item">
                            <div className="bookingsteps__item--label">
                                <span
                                    className={
                                        visible === 'confirmation'
                                            ? 'stepno stepno--active'
                                            : 'stepno'
                                    }
                                >
                                    3
                                </span>
                                <span className="steptitle">Confirmation</span>
                            </div>
                        </div>
                        <div className="bookingsteps__item">
                            <div className="bookingsteps__item--label">
                                <span
                                    className={
                                        visible === 'success'
                                            ? 'stepno stepno--active'
                                            : 'stepno'
                                    }
                                >
                                    4
                                </span>
                                <span className="steptitle">Success</span>
                            </div>
                        </div>
                    </div>
                    <div className="bookingform">
                        {errorVisible === true ? (
                            <div className="errorbox">
                                <span className="errortxt">
                                    {parse(errorMsg)}
                                </span>
                            </div>
                        ) : null}

                        {sending === true ? (
                            <div className="end">
                                <span className="end__top">
                                    Sending appointment request, please wait...
                                </span>
                            </div>
                        ) : null}

                        {visible === 'information' ? (
                            <>
                                <div className="formitem">
                                    <label className="fi__label">
                                        <input
                                            name="firstname"
                                            value={data.firstname}
                                            className={dataClass.firstname}
                                            onChange={handleChange}
                                            type="text"
                                            placeholder=" "
                                        />
                                        <span className="fi__span">
                                            First Name (required)
                                        </span>
                                    </label>
                                </div>
                                <div className="formitem">
                                    <label className="fi__label">
                                        <input
                                            name="surname"
                                            value={data.surname}
                                            className={dataClass.surname}
                                            onChange={handleChange}
                                            type="text"
                                            placeholder=" "
                                        />
                                        <span className="fi__span">
                                            Last Name (required)
                                        </span>
                                    </label>
                                </div>
                                <div className="formitem">
                                    <label className="fi__label">
                                        <input
                                            name="mobile"
                                            value={data.mobile}
                                            className={dataClass.mobile}
                                            onChange={handleChange}
                                            type="text"
                                            placeholder=" "
                                        />
                                        <span className="fi__span">
                                            Contact No. (required)
                                        </span>
                                    </label>
                                </div>
                                <div className="formitem">
                                    <label className="fi__label">
                                        <input
                                            name="email"
                                            value={data.email}
                                            className={dataClass.email}
                                            onChange={handleChange}
                                            type="email"
                                            placeholder=" "
                                        />
                                        <span className="fi__span">
                                            Email (required)
                                        </span>
                                    </label>
                                </div>
                                <div className="formitem">
                                    <label className="fi__label">
                                        <span className="fi__span prefocus">
                                            Date of Birth (required)
                                        </span>
                                    </label>
                                    <DatePicker
                                        dateFormat={'dd-MM-yyyy'}
                                        selected={
                                            data.dob === '' ? '' : data.dob
                                        }
                                        onChange={(date) => {
                                            setData((items) => ({
                                                ...items,
                                                dob: date,
                                            }));
                                        }}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        placeholderText="DD-MM-YYYY"
                                        shouldCloseOnSelect={true}
                                    />
                                </div>
                                <div className="formitem fw">
                                    <label className="fi__label">
                                        <Autocomplete
                                            onSelect={(place) =>
                                                handleAutocomplete(place)
                                            }
                                            api="pk.eyJ1IjoidmlzbnMtc3R1ZGlvIiwiYSI6ImNrbGlraW5vZDBhMDYycHBsdmk5b3ljbGQifQ.ZGUBk0PWac5GahUeVHdTpg"
                                            inputValue={data.address}
                                            className={dataClass.address}
                                        />
                                        <span className="fi__span prefocus">
                                            Address
                                        </span>
                                    </label>
                                </div>
                                <div className="formitem fw formnav">
                                    <button
                                        onClick={() => {
                                            handleNext('appointment');
                                        }}
                                    >
                                        Next
                                    </button>
                                </div>
                            </>
                        ) : null}

                        {visible === 'appointment' ? (
                            <>
                                <div className="formitem">
                                    <div className="select">
                                        <select
                                            name="site_id"
                                            onChange={handleChange}
                                            value={data.site_id}
                                            className={dataClass.site_id}
                                        >
                                            <option defaultValue hidden>
                                                Select a Clinic *
                                            </option>
                                            {clinics.length > 0
                                                ? clinics.map((a) => (
                                                      <option
                                                          key={`clinics-${a.id}`}
                                                          value={a.id}
                                                      >
                                                          {a.label}
                                                      </option>
                                                  ))
                                                : null}
                                        </select>
                                    </div>
                                </div>
                                <div className="formitem">
                                    <div className="select">
                                        <select
                                            name="practitioner_id"
                                            onChange={handleChange}
                                            value={data.practitioner_id}
                                            className={
                                                dataClass.practitioner_id
                                            }
                                        >
                                            <option defaultValue hidden>
                                                Select a Treating Clinician *
                                            </option>
                                            {practitioners.length > 0
                                                ? practitioners.length === 1
                                                    ? practitioners.map((a) => (
                                                          <option
                                                              key={`practitioner-${a.id}`}
                                                              value={a.id}
                                                          >
                                                              {
                                                                  a.label.split(
                                                                      ' '
                                                                  )[0]
                                                              }
                                                          </option>
                                                      ))
                                                    : practitioners.map((a) => (
                                                          <option
                                                              key={`practitioner-${a.id}`}
                                                              value={a.id}
                                                          >
                                                              {a.label}
                                                          </option>
                                                      ))
                                                : null}
                                        </select>
                                    </div>
                                </div>
                                <div className="formitem fw">
                                    <div className="select">
                                        <MultiSelect
                                            settings={{
                                                id: 'treatment_id',
                                            }}
                                            className={dataClass.treatment_id}
                                            multi={true}
                                            onChange={(inputValue, action) => {
                                                handleChangeMs(
                                                    inputValue,
                                                    action,
                                                    'treatment_id'
                                                );
                                            }}
                                            inputValue={data.treatment_id}
                                            placeholder="Please select one or more treatment(s)"
                                            options={treatments}
                                        />
                                    </div>
                                </div>
                                {data.bodyLocations.length > 0
                                    ? data.bodyLocations.map((a, b) => (
                                          <div
                                              className="formitem toggles"
                                              key={`treatment-${a.treatment_id}`}
                                          >
                                              <div
                                                  className={
                                                      dataClass.bodyLocations
                                                  }
                                              >
                                                  <span>
                                                      Select {a.treatment}{' '}
                                                      Treatment Location(s) *
                                                  </span>
                                                  {a.locations.length > 0
                                                      ? a.locations.map(
                                                            (c, d) => (
                                                                <div
                                                                    key={`location-${c.id}`}
                                                                >
                                                                    <Toggle
                                                                        data-counter={
                                                                            d
                                                                        }
                                                                        data-parentcounter={
                                                                            b
                                                                        }
                                                                        data-string={
                                                                            c.label
                                                                        }
                                                                        checked={
                                                                            data
                                                                                .bodyLocations
                                                                                .length >
                                                                            0
                                                                                ? data
                                                                                      .bodyLocations[
                                                                                      b
                                                                                  ] !==
                                                                                  undefined
                                                                                    ? data
                                                                                          .bodyLocations[
                                                                                          b
                                                                                      ]
                                                                                          .locations[
                                                                                          d
                                                                                      ] !==
                                                                                      undefined
                                                                                        ? data
                                                                                              .bodyLocations[
                                                                                              b
                                                                                          ]
                                                                                              .locations[
                                                                                              d
                                                                                          ]
                                                                                              .value
                                                                                        : false
                                                                                    : false
                                                                                : false
                                                                        }
                                                                        onChange={
                                                                            handleToggleLocation
                                                                        }
                                                                    />{' '}
                                                                    <small>
                                                                        {
                                                                            c.label
                                                                        }
                                                                    </small>
                                                                </div>
                                                            )
                                                        )
                                                      : null}
                                              </div>
                                          </div>
                                      ))
                                    : null}

                                <div className="formitem">
                                    <label className="fi__label">
                                        <span className="fi__span prefocus">
                                            Select a Date (required)
                                        </span>
                                    </label>
                                    <DatePicker
                                        dateFormat={'dd-MM-yyyy'}
                                        selected={
                                            data.date === '' ? '' : data.date
                                        }
                                        onChange={(date) => {
                                            setData((items) => ({
                                                ...items,
                                                date: date,
                                            }));
                                        }}
                                        minDate={moment().toDate()}
                                        includeDates={includeDates}
                                        placeholderText={datePlaceholder}
                                        shouldCloseOnSelect={true}
                                    />
                                </div>
                                <div className="formitem">
                                    <div className="select">
                                        <select
                                            name="time"
                                            onChange={handleChange}
                                            value={data.time}
                                        >
                                            <option defaultValue hidden>
                                                Select a Time *
                                            </option>
                                            {times.length > 0
                                                ? times.map((a) => (
                                                      <option
                                                          key={`times-${a.id}`}
                                                          value={a.id}
                                                      >
                                                          {a.label}
                                                      </option>
                                                  ))
                                                : null}
                                        </select>
                                    </div>
                                </div>
                                <div className="formitem fw formnav">
                                    <button
                                        onClick={() => {
                                            setVisible('information');
                                        }}
                                    >
                                        Back
                                    </button>
                                    <button
                                        onClick={() => {
                                            handleNext('confirmation');
                                        }}
                                    >
                                        Next
                                    </button>
                                </div>
                            </>
                        ) : null}

                        {visible === 'confirmation' ? (
                            <>
                                <div className="formitem fw">
                                    <div className="confirm">
                                        <span className="confirm__top">
                                            Please confirm your appointment
                                            request below:
                                        </span>
                                        <ul className="confirm__list">
                                            <li>
                                                Clinic:{' '}
                                                <span>{data.clinic}</span>
                                            </li>
                                            <li>
                                                Practitioner:{' '}
                                                <span>{data.practitioner}</span>
                                            </li>
                                            <li>
                                                Treatment:{' '}
                                                <span>
                                                    {data.bodyLocations.length >
                                                    0
                                                        ? data.bodyLocations.map(
                                                              (a, b) => (
                                                                  <React.Fragment
                                                                      key={`treatment-${a.treatment_id}`}
                                                                  >
                                                                      {b > 0
                                                                          ? ', '
                                                                          : null}
                                                                      {
                                                                          a.treatment
                                                                      }
                                                                  </React.Fragment>
                                                              )
                                                          )
                                                        : null}
                                                </span>
                                            </li>
                                            <li>
                                                Treatment Location:{' '}
                                                {data.bodyLocations.length > 0
                                                    ? data.bodyLocations.map(
                                                          (a) =>
                                                              a.locations
                                                                  .length > 0
                                                                  ? a.locations.map(
                                                                        (c) =>
                                                                            c.selected ===
                                                                            1 ? (
                                                                                <span
                                                                                    key={`body-location-${c.id}`}
                                                                                    className="locationSum"
                                                                                >
                                                                                    {
                                                                                        c.label
                                                                                    }
                                                                                    {/* {' '}
                                                                                    [
                                                                                    {
                                                                                        a.treatment
                                                                                    }

                                                                                    ] */}
                                                                                </span>
                                                                            ) : null
                                                                    )
                                                                  : null
                                                      )
                                                    : null}
                                            </li>
                                            <li>
                                                Requested date & time:{' '}
                                                <span>
                                                    {data.start !== ''
                                                        ? data.start.format(
                                                              'DD-MM-YYYY hh:mm A'
                                                          )
                                                        : null}
                                                </span>
                                            </li>
                                            <li>
                                                Consent Forms:
                                                <span className="consentDL">
                                                    {treatment.length > 0
                                                        ? treatment.map((a) =>
                                                              a.consent ? (
                                                                  <a
                                                                      onClick={() => {
                                                                          handleDownload(
                                                                              a
                                                                                  .consent
                                                                                  .file_url
                                                                          );
                                                                      }}
                                                                      key={`content-${a.id}`}
                                                                      style={{
                                                                          cursor: 'pointer',
                                                                      }}
                                                                  >
                                                                      Download{' '}
                                                                      {a.label}{' '}
                                                                      Form
                                                                  </a>
                                                              ) : null
                                                          )
                                                        : null}
                                                </span>
                                            </li>
                                            <li>
                                                Patient Consent
                                                <small className="consent">
                                                    <Toggle
                                                        name="consent"
                                                        checked={data.consent}
                                                        onChange={handleChange}
                                                    />
                                                </small>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="formitem fw formnav">
                                    <button
                                        onClick={() => {
                                            setVisible('appointment');
                                        }}
                                    >
                                        Back
                                    </button>
                                    <button
                                        disabled={
                                            data.consent === true ? false : true
                                        }
                                        onClick={() => {
                                            handleNext('success');
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </div>
                            </>
                        ) : null}

                        {visible === 'success' ? (
                            <>
                                <div className="formitem fw">
                                    <div className="end">
                                        <span className="end__top">
                                            <strong>Success!</strong> Your
                                            appointment request has been sent to
                                            the clinic. Please check your email
                                            for further details and booking
                                            confirmation.
                                        </span>
                                    </div>
                                </div>
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default IndexPage;
